var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDoorPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4254 3.10596H0V19.106H19V9.79952L11.4254 3.10596ZM18.3692 18.4779H0.630785V3.73402H11.1856L18.3692 10.0823V18.4779Z",
    fill: "#4FBC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5698 9.52711H2.17212V4.99707H10.4001L15.5698 9.52711Z",
    fill: "#4FBC9D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.106,
    width: 3,
    height: 1,
    fill: "#4FBC9D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 2.77264C18.5955 2.88546 18.4719 2.95315 18.3376 2.95315H17.8125L17.3885 2.05594L18.319 1.6153L18.6912 2.39704C18.7484 2.51914 18.7391 2.6585 18.6673 2.77264Z",
    fill: "#4FBC9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4812 3.1111L18.0265 3.91275C17.9454 4.05477 17.7939 4.14369 17.6304 4.14369L17.1332 4.14634V4.42772L16.2798 3.68712L17.1332 2.83636V3.11641L18.4812 3.1111Z",
    fill: "#4FBC9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0272 3.0859L16.0073 4.11584L15.1406 4.09858C15.0063 4.09593 14.884 4.02691 14.8149 3.91144C14.7458 3.79597 14.7391 3.65529 14.8003 3.53584L15.0356 3.06732L16.0272 3.0859Z",
    fill: "#4FBC9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.441 2.51117L15.1898 2.38641L14.5943 3.5942L14.0771 2.82971C13.9868 2.69433 13.9748 2.52046 14.0466 2.37314L14.2659 1.92719L14.0147 1.80243L15.0569 1.36975L15.441 2.51117Z",
    fill: "#4FBC9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2599 0.671595L15.7042 1.49315L14.8495 0.915806L15.336 0.1991C15.4105 0.0876118 15.5367 0.0239044 15.671 0.0278861C15.8053 0.0331951 15.9262 0.104866 15.994 0.220335L16.2599 0.671595Z",
    fill: "#4FBC9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8777 0.505737L17.6743 1.61531L16.5058 1.31535L16.7477 1.17201L16.0578 0.0159871L16.9804 6.04401e-05C17.1439 -0.00259403 17.2968 0.082349 17.3805 0.223036L17.6357 0.649078L17.8777 0.505737Z",
    fill: "#4FBC9D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white",
    transform: "translate(0 3.10596)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDoorPre);
export default __webpack_public_path__ + "static/media/car_door_pre.8b6d22652f3fd14abe37fd439ac05cdc.svg";
export { ForwardRef as ReactComponent };